import { NotificationActions, NotificationSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/notification";
import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";

import { BaseNotification, isBaseNotification } from "../../types/notification";

export const removeUnnecessaryNotificationMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	if (NotificationActions.add.match(action) && isAlsoBaseNotification(action.payload) && action.payload.group) {
		const group = action.payload.group;

		const obsoleteNotifications = NotificationSelectors.notifications()(api.getState())
			.filter(isAlsoBaseNotification)
			.filter(it => it.group === group)
			.map(it => it.id);

		if (obsoleteNotifications.length > 0) {
			api.dispatch(NotificationActions.remove(obsoleteNotifications));
		}
	}

	return next(action);
});

function isAlsoBaseNotification<T>(value: T): value is T & BaseNotification {
	return isBaseNotification(value);
}
